import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Contact } from "lucide-react";
import { cn } from "../../../utils";
import { Badge } from "../../base/badge/badge";
import { getColorSchemeFromString } from "../../base/badge/badge-utils";
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from "../../base/item/item";
import { appendDeletedSuffix, DELETED_ENTITY_CLASS, isAssigneeDeleted } from "../../../utils/deleted-entity-utils";
export const ExternalContactCard = /*#__PURE__*/ React.forwardRef(({ contact, variant = "name-only", itemVariant = "default", size = "default", className, titleSlot, descriptionSlot, rightSlot }, ref)=>{
    const { t } = useTranslation();
    const isDeleted = isAssigneeDeleted(contact);
    let secondaryText = null;
    if (variant === "with-email") {
        secondaryText = contact.email;
    }
    const showDescription = descriptionSlot ?? secondaryText;
    const showTypeBadge = variant === "with-type" && contact.type;
    return /*#__PURE__*/ _jsxs(Item, {
        ref: ref,
        variant: itemVariant,
        size: size,
        className: cn(className, isDeleted && DELETED_ENTITY_CLASS),
        children: [
            /*#__PURE__*/ _jsx(ItemMedia, {
                variant: "icon",
                children: /*#__PURE__*/ _jsx(Contact, {
                    className: "h-4 w-4"
                })
            }),
            /*#__PURE__*/ _jsxs(ItemContent, {
                children: [
                    /*#__PURE__*/ _jsx(ItemTitle, {
                        children: titleSlot ?? appendDeletedSuffix(contact.name, isDeleted, t)
                    }),
                    showDescription && /*#__PURE__*/ _jsx(ItemDescription, {
                        children: showDescription
                    })
                ]
            }),
            rightSlot ? rightSlot : showTypeBadge && /*#__PURE__*/ _jsx(Badge, {
                variant: "outline",
                colorScheme: getColorSchemeFromString(contact.type ?? ""),
                className: "self-center",
                children: contact.type
            })
        ]
    });
});
ExternalContactCard.displayName = "ExternalContactCard";

//# sourceMappingURL=external-contact-card.js.map